module.exports = __webpack_public_path__ + "img/home@2x.bf376a3b.png";